// @ts-nocheck
import React, { useEffect, useState } from "react";
import InitialInformation from "pages/applications/tabs/submissions/InitialInformation";
import MerchantBusinessInformation from "pages/applications/tabs/submissions/MerchantBusinessInformation";
import MerchantBusinessOwner from "pages/applications/tabs/submissions/MerchantBusinessOwner";
import DBAInformation from "./DBAInformation";
import AffiliatedBusiness from "./AffiliatedBusiness";
import MerchantPaymentInfo from "./MerchantPaymentInfo";
import { MerchantProvider } from "./MerchantContext";
import { useSubmissionStore } from "../../../../models/applications/SubmissionStore";

const Submission = ({ merchantData, dealApplicationId, isReadOnly, fetchUsersRole }) => {
  const { merchantBusinessInfo } = useSubmissionStore();
  const [merchantsExists, setMerchantExists] = useState<boolean>(true);

  useEffect(() => {
    setMerchantExists(!!(merchantBusinessInfo?.merchantId || merchantBusinessInfo?.merchantName));
  }, [merchantBusinessInfo]);

  return (
    <MerchantProvider>
      <div style={isReadOnly ? { pointerEvents: "none", opacity: 0.7 } : {}}>
        <InitialInformation
          merchantData={merchantData}
          dealApplicationId={dealApplicationId}
          fetchUsersRole={fetchUsersRole}
        />
        <div style={merchantsExists ? {} : { pointerEvents: "none", opacity: 0.6 }}>
          <MerchantBusinessInformation />
          <MerchantBusinessOwner />
          <DBAInformation />
          <AffiliatedBusiness />
        </div>
        <MerchantPaymentInfo dealApplicationId={dealApplicationId} />
      </div>
    </MerchantProvider>
  );
};

export default Submission;
